<!-- Primary router outlet -->
<p-toast position="bottom-right" key="app_notiy" [baseZIndex]="100" [style]="{'z-index': '999999'}"></p-toast>
<router-outlet></router-outlet>